import { forwardRef, ReactNode } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import { SxProps } from "@mui/material";

type Props = {
  sx?: SxProps;
  value: boolean;
  isDisabled?: boolean;
  onChange?: CheckboxProps["onChange"];
  label?: string | ReactNode;
  error?: boolean;
  testId?: string;
};

const CustomizedCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ sx, value, isDisabled, onChange, label, error, testId }, ref) => {
    return (
      <FormControlLabel
        ref={ref}
        control={
          <Checkbox
            data-test-id={testId}
            checked={value}
            value={value}
            disabled={isDisabled}
            onChange={onChange}
            sx={{ ...sx, color: error ? "error.main" : "#BDBDBD" }}
          />
        }
        label={label}
      />
    );
  }
);

export default CustomizedCheckbox;
